import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, firstValueFrom } from 'rxjs';
import { SelectControlValueAccessor } from '@angular/forms';
import { EncrdecrService } from '../Auth/encrdecr.service';
import { ConvertToJSONService } from './convert-to-json.service';

const headers = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }

@Injectable({
  providedIn: 'root'
})
export class IfdOnboardingService {

  ServerUrl = environment.ServerUrl.replace(/\/+$/, ''); // "http://173.212.234.56:8012";//"http://173.249.23.172:8888";
  constructor(private http: HttpClient, private EncrdecrService: EncrdecrService, private ConvertToJSON: ConvertToJSONService) { }

  getAppDrodownlist(TRANS_TYPE): Observable<any> {
    const url = `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=${TRANS_TYPE}&REFF_ID=&CON_STR=SMC`;
    // return this.http.get<any>(url,this.GetToken());
    ////console.log(url)   ;
    //return this.http.get<any>(url);
    return this.http.get<any>(url, this.GetToken());
  }
  GetToken() {
     
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);

    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Basic ${TOKEN}`,
      })
    }
    return tokenOption;
  }

  GuardianRelationList(): Observable<any> {
    //const token = this.GetToken();
    let trans_type = this.EncrdecrService.setEncr('GUARDIAN_RELATIONSHIP_LIST');
    let SUrl = `${this.ServerUrl}/api/DropDown/ListDetails?TRANS_TYPE=${trans_type}`;
    let url = SUrl.split('?')[0];
    let body = this.ConvertToJSON.QueryStringToJSON(SUrl.split('?')[1]);
    console.log("GuardianRelationList Master URL is " + url);
    console.log("GuardianRelationList Master body is " + JSON.stringify(body));
    return this.http.post<any>(url, body);
  }
  
  GetTokenwithoutcontenttype() {
    //
    if (sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != null && sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != '') {
      let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
      let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));

      ////console.log(token + "@" + UserId);
      const TOKEN = btoa(token + "@" + UserId);
      const tokenOption = {
        headers: new HttpHeaders({
          'Authorization': `Basic ${TOKEN}`,
        })
      }
      return tokenOption;
    }
    else if (sessionStorage.getItem('G&&&uuu##ee@@ss!!t') != null && sessionStorage.getItem('G&&&uuu##ee@@ss!!t') != '') {
      let token = sessionStorage.getItem('G&&&uuu##ee@@ss!!t');
      let UserId = "Guest";

      ////console.log(token + "@" + UserId);
      const TOKEN = btoa(token + "@" + UserId);
      const tokenOption = {
        headers: new HttpHeaders({
          'Authorization': `Basic ${TOKEN}`,
        })
      }
      return tokenOption;
    }

  }


  GetDetails(SubBrokerID): Observable<any> {
    //SubBrokerID=0;
    //
    debugger
    let sbidencrypt = this.EncrdecrService.setEncr(SubBrokerID);
    const url = `${this.ServerUrl}/api/IFDOnBoarding/DetailsByID?TRANS_TYPE=SUBBROKER_BYID&SubBrokerID=${sbidencrypt}`;
    //console.log(url)   ;
    // if(SubBrokerID==0)
    // return this.http.get<any>(url);
    // else
    const dataurl = url.split('?')[0];
    const json = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);
    return this.http.post<any>(dataurl, json, this.GetToken());
    //return this.http.get<any>(url);
  }

  SubmitDetails(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/IFDOnBoarding/Details`;
    let request = { data: this.EncrdecrService.setEncr(formData) }
    return this.http.post<any>(url, request, this.GetToken());
  }
  SubmitPreOnBoardingDetails(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/IFDOnBoarding/PostPreOnBoardingDetails`;
    let request = { data: this.EncrdecrService.setEncr(formData) }
    return this.http.post<any>(url, request, headers);
  }

  SubmitBrokrageDetails(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/IFDOnBoarding/Postbrokragedetails`;

    return this.http.post<any>(url, formData, this.GetToken());
  }

  UploadDocumentJson(formData: any): Observable<any> {
    let url = `${this.ServerUrl}/api/IFDOnBoarding/UploadDocuments`;

    return this.http.post<any>(url, formData, this.GetToken());


  }
  UploadDocument(formData: any): Observable<any> {
    let url = `${this.ServerUrl}/api/IFDOnBoarding/UploadDocumentsFormData`;
    //let url =`http://localhost:24938/api/IFDOnBoarding/UploadDocumentsFormData`;
    ////console.log(url)
    return this.http.post<any>(url, formData, this.GetTokenwithoutcontenttype());
  }
  UploadFeeDocument(formData: any): Observable<any> {
    let url = `${this.ServerUrl}/api/IFDOnBoarding/FeesAndDeposite`;
    //let url =`http://localhost:24938/api/IFDOnBoarding/UploadDocumentsFormData`;
    ////console.log(url)
    return this.http.post<any>(url, formData, this.GetTokenwithoutcontenttype());
  }
  async GetDocument(docId, SbId): Promise<Observable<any>> {
    //SubBrokerID=0;
    debugger;
    const DataUrl = `${this.ServerUrl}/api/IFDOnBoarding/GetDocuments_POST?SBDocumentId=${docId}&SubBrokerID=${SbId}&TRANS_TYPE=SBDoc`;
    ////console.log(url)   ;
    //return this.http.get<any>(url);
    let url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.get<any>(url, this.GetToken());
    const result = await this.postAPICall(body, "/api/IFDOnBoarding/GetDocuments_POST",this.GetToken());
    return result;
  }
  async GetDocumentCheque(docId, SbId): Promise<Observable<any>> {
    //SubBrokerID=0;
    debugger;
    const DataUrl = `${this.ServerUrl}/api/IFDOnBoarding/GetDocuments_POST?SubBrokerID=${SbId}&TRANS_TYPE=DocCheque`;
    let url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.get<any>(url, this.GetToken());
    const result = await this.postAPICall(body, "/api/IFDOnBoarding/GetDocuments_POST",this.GetToken());
    return result;
    ////console.log(url)   ;
    //return this.http.get<any>(url);
    // return this.http.get<any>(url, this.GetToken());
  }
  async GetDocumentPAN(docId, SbId): Promise<Observable<any>> {
    //SubBrokerID=0;
    debugger;
    const DataUrl = `${this.ServerUrl}/api/IFDOnBoarding/GetDocuments_POST?SubBrokerID=${SbId}&TRANS_TYPE=DocPAN`;
    ////console.log(url)   ;
    //return this.http.get<any>(url);
    // return this.http.get<any>(url, this.GetToken());
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.get<any>(url, this.GetToken());
    const result = await this.postAPICall(body, "/api/IFDOnBoarding/GetDocuments_POST",this.GetToken());
    return result;
  }
  async GetDocumentGST(docId, SbId): Promise<Observable<any>> {
    //SubBrokerID=0;
    debugger;
    const DataUrl = `${this.ServerUrl}/api/IFDOnBoarding/GetDocuments_POST?SubBrokerID=${SbId}&TRANS_TYPE=DocGST`;
    ////console.log(url)   ;
    //return this.http.get<any>(url);
    // return this.http.get<any>(url, this.GetToken());
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.get<any>(url, this.GetToken());
    const result = await this.postAPICall(body, "/api/IFDOnBoarding/GetDocuments_POST",this.GetToken());
    return result;
  }
  async GetDocumentPhoto(docId, SbId): Promise<Observable<any>> {
    //SubBrokerID=0;
    debugger;
    const DataUrl = `${this.ServerUrl}/api/IFDOnBoarding/GetDocuments_POST?SubBrokerID=${SbId}&TRANS_TYPE=PHOTO`;
    ////console.log(url)   ;
    //return this.http.get<any>(url);
    // return this.http.get<any>(url, this.GetToken());
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.get<any>(url, this.GetToken());
    const result = await this.postAPICall(body, "/api/IFDOnBoarding/GetDocuments_POST",this.GetToken());
    return result;
  }
  IMPSService(formData: any): Observable<any> {
    let url = `${this.ServerUrl}/api/IMPSService/Details`;
    ////console.log(url)
    return this.http.post<any>(url, formData, this.GetToken());
  }

  KnowKYC(PanNo, DOB, mobileno): Observable<any> {
    //SubBrokerID=0;
    const url = `${this.ServerUrl}/api/CVLKRAData/GetCVLKRADATA?PANNo=${PanNo}&DOB=${DOB}&MobileNo=${mobileno}`;
    ////console.log(url)   ;
    // return this.http.get<any>(url);
    return this.http.get<any>(url, this.GetToken());
  }

  UploadCertificateFormData(formData: any): Observable<any> {
    let url = `${this.ServerUrl}/api/IFDOnBoarding/UploadDocumentsFormData`;
    //let url =`http://localhost:24938//api/IFDOnBoarding/UploadCertificateFormData`;
    ////console.log(url)
    return this.http.post<any>(url, formData, this.GetTokenwithoutcontenttype());
  }

  // IsPANExsist(PAN):Observable<any>{
  //   const url = `${this.ServerUrl}/api/CheckPANExsitsOrNot/Details?TRANS_TYPE=ClientPAN&TRANS_VALUE=${PAN}`;
  //   return this.http.get<any>(url);
  // }
  IsPANExsistNew(formData: any): Observable<any> {
    const url = `${this.ServerUrl}/api/FranchiseePanCheck/Details`;
    return this.http.post<any>(url, formData, headers);
  }
  // GetBankDetails(IFSC):Observable<any>{
  //   const url = `${this.ServerUrl}/api/FillBank_details/Details?Flag=IFSC&Code=${IFSC}`;
  //   return this.http.get<any>(url);
  // }
  GetBankDetailsNew(formData: any): Observable<any> {
    const url = `${this.ServerUrl}/api/FranchiseeBank/Details`;
    return this.http.post<any>(url, formData, this.GetToken());
  }
  // GetCityStateCountryDetails(PIN):Observable<any>{
  //   const url = `${this.ServerUrl}/api/FillBank_details/Details?Flag=&Code=${PIN}`;
  //   return this.http.get<any>(url);
  // }
  GetCityStateCountryDetailsNew(formData: any): Observable<any> {
    const url = `${this.ServerUrl}/api/FranchiseePinCode/Details`;
    let body = { data: this.EncrdecrService.setEncr(formData) };
    return this.http.post<any>(url, body, headers);
  }
  CompleteProfileByRM(data: any): Observable<any> {
    let url = `${this.ServerUrl}/api/SBSignUpLog/Details`;
    ////console.log(url)
    let request = { data: this.EncrdecrService.setEncr(data) }
    return this.http.post<any>(url, request, this.GetToken());
  }

  GetAndVerifyOTP(data: any): Observable<any> {
    let url = `${this.ServerUrl}/api/OTP_Birla/Details`;
    ////console.log(url)
    return this.http.post<any>(url, data, this.GetToken());
  }

  GetBrokrageDetails(flage: any, subbrokerid: any): Observable<any> {
    const url = `${this.ServerUrl}/api/IFDOnBoarding/GetBrokrageDetails?Flag=${flage}&SubbrokerID=${subbrokerid}`;
    //return this.http.get<any>(url);
    return this.http.get<any>(url, this.GetToken());
  }

  GetDocumentDetails(subbrokerid: any, docid: any): Observable<any> {
    const url = `${this.ServerUrl}/api/IFDOnBoarding/GetDocumentDetails?SubbrokerID=${subbrokerid}&DocId=${docid}`;
    //return this.http.get<any>(url);
    return this.http.get<any>(url, this.GetToken());
  }

  GetDocumentDetailspost(subbrokerid: any, docid: any): Observable<any> {
    const url = `${this.ServerUrl}/api/IFDOnBoarding/GetDocumentDetailsPost`;
    let TempDataBody = {
      "SubBrokerCode": subbrokerid,
      "DocumentId": docid

    }

    let DataBody = JSON.stringify(TempDataBody);
    const tokenOption = this.GetToken();

    let request = { data: this.EncrdecrService.setEncr(DataBody) }
    ////console.log(url)
    // return this.http.post<any>(url, DataBody, this.GetToken());
    return this.http.post<any>(url, request, tokenOption);
  }

  PostZohorequest(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/ZohoCRMAPIFetchRecord/ReqCRMFetchRecord`;

    return this.http.post<any>(url, formData, this.GetToken());
  }
  GetPdfWitheSignNdeFranking(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/IFDOnBoarding/GetPdfWitheSignNdeFranking`;

    return this.http.post<any>(url, formData, this.GetToken());
  }
  GetFeeAndDepositespost(subbrokerid: any): Observable<any> {
    const url = `${this.ServerUrl}/api/IFDOnBoarding/GetFeesandDepositeDetails?SubbrokerID=${subbrokerid}`;
    let TempDataBody = {
      "SubBrokerCode": subbrokerid,


    }

    let DataBody = JSON.stringify(TempDataBody);
    const tokenOption = this.GetToken();

    ////console.log(url)
    // return this.http.post<any>(url, DataBody, this.GetToken());
    return this.http.get<any>(url, this.GetToken());
    //return this.http.Get<any>(url, DataBody,tokenOption );
  }
  getAppDrodownlistRef(TRANS_TYPE, RefID): Observable<any> {
    const url = `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=${TRANS_TYPE}&REFF_ID=${RefID}&CON_STR=SMC`;
    // return this.http.get<any>(url,this.GetToken());
    //console.log(url)   ;
    //return this.http.get<any>(url);
    return this.http.get<any>(url, this.GetToken());
  }
  GetRmCodeReferral(): Observable<any> {
    const url = `${this.ServerUrl}/api/IFDOnBoarding/GetRMCodeForReferral`;
    //return this.http.get<any>(url);
    return this.http.get<any>(url, this.GetToken());
  }
  ReferalLog(formData: any): Observable<any> {
    const url = `${this.ServerUrl}/api/FranchiseePanCheck/LogDetails`;
    return this.http.post<any>(url, formData, headers);
  }
  GetFanRegistration(SubbrokerId): Observable<any> {
    const url = `${this.ServerUrl}/api/IIFLFranchiessOnboarding/Details?SubBrokerID=${SubbrokerId}`;
    //return this.http.get<any>(url);
    return this.http.get<any>(url, this.GetToken());
  }
  GetPdfWithestampFranking(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/EFranking/GetPdfWithestampFranking`;

    return this.http.post<any>(url, formData, this.GetToken());
  }

  GetPdfWithstampeSignNdeFranking(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/EFranking/GetPdfWithestampFrankingEsign`;

    return this.http.post<any>(url, formData, this.GetToken());
  }
  BindDropList(TransType: any): Observable<any> {
    //const token = this.GetToken();
    let trans_type = this.EncrdecrService.setEncr(TransType);
    let SUrl = `${this.ServerUrl}/api/DropDown/ListDetails?TRANS_TYPE=${trans_type}`;
    let url = SUrl.split('?')[0];
    let body = this.ConvertToJSON.QueryStringToJSON(SUrl.split('?')[1]);
    console.log("NSEStateList Master URL is " + url);
    console.log("NSEStateList Master body is " + JSON.stringify(body));
    return this.http.post<any>(url, body, headers);
  }





































  GetResumePANMob(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/ForgotPassword/ReportDetails`;
    return this.http.post<any>(url, formData, headers);
  }
  IsPANExsist(formData): Observable<any> {
    debugger
    let url = `${this.ServerUrl}/api/PANCheck/PANValidation`;
    let request = { data: this.EncrdecrService.setEncr(formData) }
    return this.http.post<any>(url, request, headers);
  }
  IsPANDedup(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/PANCheck/PANCheck`;
    return this.http.post<any>(url, formData, headers);
  }
  HSLLogin(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/HSLLogin/LoginCall`;
    return this.http.post<any>(url, formData, headers);
  }
  FetchCustomerDetails(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/FetchcustomerDetails/FetchcustomerDetails`;
    return this.http.post<any>(url, formData, headers);
  }
  SendSMStoHSLClient(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/OTP_Franch/Details`;
    return this.http.post<any>(url, formData, headers);
  }
  SendSMSonCodeCreation(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/OTP_Franch/Details`;
    return this.http.post<any>(url, formData, headers);
  }
  OTPVerification(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/OTP_Franch/Details`;
    return this.http.post<any>(url, formData, headers);
  }
  FetchCVLKRAData(formData,rid="",jid="",userType=0, initiatedBy=""): Observable<any> {
    let url = `${this.ServerUrl}/api/CVLKRAData/CVLKRAAPI`;
    let request = 
    { 
      data: this.EncrdecrService.setEncr(formData),
      rid: rid,
      jid: jid,
      userType: userType,
      initiatedBy: initiatedBy 
    }
    return this.http.post<any>(url, request, headers);
  }
  DigiLockerCreatTokenRequest(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/DigiLockerV2/CreateKYCRequest`;
    let request = {
      data: this.EncrdecrService.setEncr(formData)
    }
    return this.http.post<any>(url, request, headers);
  }
  DigiLockerFetchResponse(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/DigiLockerV2/KYCRequestStatusAndDetails`;
    let request = {
      data: this.EncrdecrService.setEncr(formData)
    }
    return this.http.post<any>(url, request, headers);
  }

  DigiLockerFetchResponseforClient(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/DigiLockerV2/KYCRequestStatusAndDetailsClient`;
    let request = {
      data: this.EncrdecrService.setEncr(formData)
    }
    return this.http.post<any>(url, request, headers);
  }

  PennyDrop(DataBody) {
    const url = `${this.ServerUrl}/api/PennyDrop/PennyDrop`;
    return this.http.post<any>(url, DataBody, headers);
  }
  // GetBankDetailsNew(formData: any):Observable<any>{
  //   const url = `${this.ServerUrl}/api/FranchiseeBank/Details`;
  //   return this.http.post<any>(url, formData,headers);
  // }
  // GetCityStateCountryDetailsNew(formData: any):Observable<any>{
  //   const url = `${this.ServerUrl}/api/FranchiseePinCode/Details`;
  //   return this.http.post<any>(url, formData,headers);
  // }
  IPVCreateToken(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/CreateProfile/Sync`;
    return this.http.post<any>(url, formData, headers);
  }
  IPVGetProfile(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/CreateProfile/GetProfile`;
    return this.http.post<any>(url, formData, headers);
  }
  ESignCreateToken(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/DigiLockerV2/CreateSignatureRequestEsign`;
    let request = {
      data: this.EncrdecrService.setEncr(formData)
    }
    return this.http.post<any>(url, request, headers);
  }

  NonKYCESignRequest(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/DigiLockerV2/CreateSignatureRequestEsignNonKYC`;
    let request = {
      data: this.EncrdecrService.setEncr(formData)
    }
    return this.http.post<any>(url, request, headers);
  }

  MultiholderESignRequest(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/DigiLockerV2/CreateSignatureRequestEsignMultiholder`;
    let request = {
      data: this.EncrdecrService.setEncr(formData)
    }
    return this.http.post<any>(url, request, headers);
  }

  NSDLNameCheckAPI(formData,rid="",jid="",userType=0, initiatedBy=""): Observable<any> {
    let url = `${this.ServerUrl}/api/NSDLAPI/NameCheck`;
    let request = {
      data: this.EncrdecrService.setEncr(formData),
      rid: rid,
      jid: jid,
      userType: userType,
      initiatedBy: initiatedBy 
    }
    return this.http.post<any>(url, request, headers);
  }

  GetHypervergeToken(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/Hyperverge/GetToken`;
    let request = {
      data: this.EncrdecrService.setEncr(formData)
    }
    return this.http.post<any>(url, request, headers);
  }

  UpdateNewName(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/NSDLAPI/UpdateNewName`;
    let request = {
      data: this.EncrdecrService.setEncr(formData)
    }
    return this.http.post<any>(url, request, headers);
  }

  CallDownloadDocumentAPI(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/DigiLockerV2/CallDownloadDocumentAPI`;
    let request = {
      data: this.EncrdecrService.setEncr(formData)
    }
    return this.http.post<any>(url, request, headers);
  }

  CallNonKYCDownloadDocumentAPI(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/DigiLockerV2/CallDownloadDocumentAPIKYCForm`;
    let request = {
      data: this.EncrdecrService.setEncr(formData)
    }
    return this.http.post<any>(url, request, headers);
  }
  EsingDownloadDocument(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/DigiLockerV2/EsingDownloadDocument`;
    let request = {
      data: this.EncrdecrService.setEncr(formData)
    }
    return this.http.post<any>(url, request, headers);
  }
  DeleteRP(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/IFDOnBoarding/Details`;
    let request = { data: this.EncrdecrService.setEncr(formData) }
    return this.http.post<any>(url, request, this.GetToken());

  }
  GetAddressByPin(PinCode) {
    let DataUrl = `${this.ServerUrl}/api/FillBank_details/GetDetail?Flag=&Code=${PinCode}`
    const tokenOption = this.GetToken();
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  GetBankByIFSC(IFSCCode) {
    let DataUrl = `${this.ServerUrl}/api/FillBank_details/GetDetail?Flag=IFSC&Code=${IFSCCode}`
    const tokenOption = this.GetToken();
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();

  }
  LivelinessAPI(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/Liveliness/SaveLivelinessResponse`;
    return this.http.post<any>(url, formData, headers);
  }

  getLatestImage(req): Observable<any> {
    let url = `${this.ServerUrl}/api/Liveliness/GetLatestImage`;
    return this.http.post<any>(url, req, headers);
  }

  async GetCoBrandingDocument(SbId): Promise<Observable<any>> {
    debugger;
    //SubBrokerID=0;
    const DataUrl = `${this.ServerUrl}/api/IFDOnBoarding/GetDocuments_POST?SubBrokerID=${SbId}&TRANS_TYPE=CoBrandingLogo`;
    ////console.log(url)   ;
    //return this.http.get<any>(url);
    // return this.http.get<any>(url, this.GetToken());
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.get<any>(url, this.GetToken());
    const result = await this.postAPICall(body, "/api/IFDOnBoarding/GetDocuments_POST",this.GetToken());
    return result;
  }

  //Added By Devang Mehta On 13-12-2024
  async KYCInquiry(formData): Promise<Observable<any>> {
    let url = `/api/CVLKRAData/CVLKRAInquiry`;
    let request = { data: this.EncrdecrService.setEncr(formData) }
    // return this.http.post<any>(url, request, headers);
    const result = await this.postAPICall(request, url,headers);
    return result;
  }
  //End By Devang Mehta
  async postAPICall(Request: any, URL: any,headersdy = {}): Promise<any> {
    let Url = `${this.ServerUrl}${URL}`;
    // let Url = `http://localhost:2010/${URL}`;

    let KeyPair = await this.EncrdecrService.getKeyPair();
    Request.publicKey = KeyPair.publicKeySpkiBase64;

    let EncryptedData = await this.EncrdecrService.encryptJson(Request, environment.RSA_PUBLIC_KEY_BASE64);

    let body = {
      "EncryptedData": EncryptedData.encryptedData,
      "dvfv": EncryptedData.encryptedKey,
      "sdcsd": EncryptedData.iv
    };
    if(!headersdy){
      headersdy = headers
    }
    const response = await firstValueFrom(this.http.post<any>(Url, body, headersdy));

    const DecryptedResponse = this.EncrdecrService.decryptResponse(
      response.EncryptedDataBase64,
      response.EncryptedAesKeyBase64,
      response.IvBase64,
      KeyPair.privateKeyPem
    );

    return DecryptedResponse;
  }

  // Added By Sourabh 

   DigiLockerCreatTokenRequestForSelfie(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/DigiLockerV2/CreateKYCRequestForSelfie`;
    let request = {
      data: this.EncrdecrService.setEncr(formData)
    }
    return this.http.post<any>(url, request, headers);
  }

    
  DigiLockerFetchResponseforSelfie(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/DigiLockerV2/KYCRequestStatusforSelfie`;
    let request = {
      data: this.EncrdecrService.setEncr(formData)
    }
    return this.http.post<any>(url, request, headers);
  }
}
